import { render } from "./AmendBookingSuccess.vue?vue&type=template&id=ff20d402&lang=pug"
import script from "./AmendBookingSuccess.vue?vue&type=script&lang=ts"
export * from "./AmendBookingSuccess.vue?vue&type=script&lang=ts"
script.render = render

export default script